import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@r1-compass-library/services/login.service';
import { GlobalLoggedInUserStore } from '@r1-compass-library/store/logged-in-user/global-logged-in-user.store';
import { Observable } from 'rxjs';
import { AppConstants } from '../components/app.constants';

export class InterceptorConstants {
    static invalidRefreshToken = 'Invalid refresh';
    static encodedTokenIsRefreshToken = 'Encoded token is a refresh token';
    static cannotConvertAccessToken = 'Cannot convert access token to JSON';
}

export function compassHttpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const loginService = inject(LoginService);
    const loggedInUserStore = inject(GlobalLoggedInUserStore);
    const router = inject(Router);

    const selectedDivision = loggedInUserStore
        .usersAvailableDivisions()
        .find(div => div.id === loggedInUserStore.selectedIamDivisionId())?.divisionCode;

    const bypassList = ['signin', 'amazonaws.com'];

    for (const entry of bypassList) {
        if (req.url.includes(entry)) {
            return next(req);
        }
    }

    const getAuthToken = () => loginService.getToken();

    const isDivTokenValidation = (url: string): boolean => url.includes('/validateDivToken');

    const isInAdminSettings = (url: string): boolean => url.includes(AppConstants.AdminSettingsComponent.path);

    const getAuthorizationHeaderName = (url: string): 'Authorization' | 'authtoken' =>
        isDivTokenValidation(url) ? 'Authorization' : 'authtoken';

    const addSecurityData = (req: HttpRequest<unknown>, token: string): HttpRequest<unknown> => {
        const headerName = getAuthorizationHeaderName(req.url);
        const updatedHeaders = req.headers.append(
            headerName,
            headerName === 'Authorization' ? `Bearer ${token}` : token
        );

        const shouldAddDivision = !isInAdminSettings(router.url) && !isDivTokenValidation(req.url);
        const updatedParams = shouldAddDivision ? req.params.append('division', selectedDivision ?? '') : req.params;

        return req.clone({
            headers: updatedHeaders,
            params: updatedParams,
        });
    };
    return next(addSecurityData(req, getAuthToken()));
}
